var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M72.3 144.6C32.4 144.6 0 112.2 0 72.3S32.4 0 72.3 0s72.3 32.4 72.3 72.3c0 11.1-2.6 22.1-7.5 32l6.5 21.1c.4 1.3.1 2.6-.7 3.7-.8 1.1-2.1 1.6-3.4 1.5l-22.4-1.6c-12.6 10.1-28.5 15.6-44.8 15.6zM72.3 8C36.8 8 8 36.9 8 72.3s28.9 64.3 64.3 64.3c15 0 29.6-5.3 41.1-14.8.8-.7 1.8-1 2.8-.9l18.1 1.3-5.3-17.1c-.3-1-.2-2.1.3-3 4.8-9.3 7.3-19.3 7.3-29.7C136.6 36.8 107.8 8 72.3 8zm22.9 60.3H75.8V48.9h-8v19.4H48.4v8h19.4v19.4h8V76.3h19.4v-8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.54eb75c5e748d5fd858dd8b22e212916.svg";
export { ForwardRef as ReactComponent };